import { render, staticRenderFns } from "./platformInput.vue?vue&type=template&id=763fabdc&scoped=true&"
import script from "./platformInput.vue?vue&type=script&lang=js&"
export * from "./platformInput.vue?vue&type=script&lang=js&"
import style0 from "./platformInput.vue?vue&type=style&index=0&id=763fabdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763fabdc",
  null
  
)

export default component.exports